import { useEffect, useState } from 'react'

export default function useGetViewportSize() {
  const SM_SIZE = 640
  const MD_SIZE = 720
  const LG_SIZE = 1040
  const XL_SIZE = 1280
  const [viewport, setViewport] = useState(typeof window !== 'undefined' ? window?.innerWidth : '375')

  function getViewportSize(width) {
    if (width < SM_SIZE) {
      return '375'
    }
    if (width < MD_SIZE) {
      return '412'
    }
    if (width < LG_SIZE) {
      return '1040'
    }
    if (width < XL_SIZE) {
      return '1440'
    } else {
      return '1920'
    }
  }
  const handleResize = () => {
    setViewport(getViewportSize(window.innerWidth))
  }

  useEffect(() => {
    setViewport(getViewportSize(window.innerWidth))
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (window.screen.width < window.innerWidth) {
      setViewport(getViewportSize(window.screen.width))
    } else {
      setViewport(getViewportSize(window.innerWidth))
    }
  }, [])

  return viewport
}
